import React from 'react';
import PropTypes from 'prop-types';
import FontPicker from '../common/FontPicker';
import { SketchPicker } from 'react-color';
import $ from 'jquery';
import t from '../i18n/I18n';

import './assets/FontPickerStyle.css';

export default class AddTextComponent extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    font: PropTypes.string,
    fontSize: PropTypes.number,
    color: PropTypes.string,
    onColorChangeComplete: PropTypes.func,
    fontStyle: PropTypes.object,
    arrowSide: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      bold: this.props.fontStyle === undefined ? false : this.props.fontStyle.bold,
      italic: this.props.fontStyle === undefined ? false : this.props.fontStyle.italic,
      underline: this.props.fontStyle === undefined ? false : this.props.fontStyle.underline,
      fontSize: props.fontSize,
      font: props.font,
      overflowParent: false,

      displayColorPicker: false,
    };

    this.fontChanged = this.fontChanged.bind(this);
    this.fontSizeChanged = this.fontSizeChanged.bind(this);
    this.toggleTextBold = this.toggleTextBold.bind(this);
    this.toggleTextItalic = this.toggleTextItalic.bind(this);
    this.toggleTextUnderline = this.toggleTextUnderline.bind(this);
    this.toggleColorPicker = this.toggleColorPicker.bind(this);
    this.handleColorChangeComplete = this.handleColorChangeComplete.bind(this);
  }

  isFontPickerOverflowRight() {
    const parentRect = $('#AssetImagePreview')[0].getBoundingClientRect();
    const fontPicker = $(this.refs.fontPickerRoot)[0];
    const fontPickerRect = fontPicker.getBoundingClientRect();
    if (this.props.arrowSide === 'right') {
      return (parentRect.x + parentRect.width) < (fontPickerRect.x + fontPickerRect.width);
    } else {
      return (parentRect.x + parentRect.width) < (fontPickerRect.x + fontPickerRect.width * 2 + 150);
    }
  }

  checkParentOverflow() {
    if (this.refs.fontPickerRoot) {
      const overflowParent = this.isFontPickerOverflowRight();
      if (overflowParent !== this.state.overflowParent) {
        this.setState({overflowParent});
        this.props.onParentOverflow(overflowParent);
      }
    }
  }

  componentDidUpdate() {
    this.checkParentOverflow();
  }

  componentDidMount() {
    this.checkParentOverflow();
  }

  fontChanged(selectedFont) {
    this.state.font = selectedFont;
    this.setState({ font: this.state.font });
    this.triggerOnChange();
  }

  fontSizeChanged() {
    this.state.fontSize = this.refs.inputSize.value;
    this.setState({ fontSize: this.state.fontSize });
    this.triggerOnChange();
  }

  toggleTextBold() {
    this.state.bold = !this.state.bold;
    this.setState({ bold: this.state.bold });
    this.triggerOnChange();
  }

  toggleTextItalic() {
    this.state.italic = !this.state.italic;
    this.setState({ italic: this.state.italic });
    this.triggerOnChange();
  }

  toggleTextUnderline() {
    this.state.underline = !this.state.underline;
    this.setState({ unerline: this.state.underline });
    this.triggerOnChange();
  }

  triggerOnChange() {
    this.props.onChange(this.state);
  }

  toggleColorPicker() {
    if (this.state.displayFontPicker) this.toggleFontPicker();
    this.setState({displayColorPicker: !this.state.displayColorPicker});
  }

  isColorPickerActive() {
    return this.state.displayColorPicker;
  }

  handleColorChangeComplete(color) {
    if (this.props.onColorChangeComplete)
      this.props.onColorChangeComplete(color);
  }

  render() {
    let fontPickerPos = 'bottom';
    if (this.state.displayColorPicker && this.refs.fontPickerRoot) {
      const thisRect = $(this.refs.fontPickerRoot)[0].getBoundingClientRect();
      const parentRect = $('#AssetImagePreview')[0].getBoundingClientRect();
      const PICKER_HEIGHT = 286;
      if (thisRect.y + thisRect.height + PICKER_HEIGHT > parentRect.y + parentRect.height) {
        fontPickerPos = 'top';
      }
    }

    return (
      <div
        name="FontPickerComponent"
        className={'FontPickerContainer ' + (this.props.arrowSide === 'right' ? 'FontPickerContainerRight' : 'FontPickerContainerLeft')}
        ref="fontPickerRoot">
        <div className="FontBlock">
          <FontPicker
            label="Select Font"
            fonts={["Arial", "Courier New", "Helvetica", "Times New Roman"]}
            previews={ true }
            activeColor="#64B5F6"
            value={ this.state.font }
            onChange={ this.fontChanged }
          />
        </div>
        <div className="VerticalSep" style={{ marginLeft: '15px' }}/>
        <div className="TextAttributesBlock">
          <div
            style={ {...styles.fontColorBtn, backgroundColor: this.props.color} }
            onClick={ this.toggleColorPicker }/>
          <i
            className="fa fa-bold center top" aria-hidden="true" title="Bold"
            style={{
              ...(!this.state.bold ? styles.textAttributeIcon : styles.textAttributeIconActive) }}
            onClick={ this.toggleTextBold }
          />
          <i
            className="fa fa-italic center top" aria-hidden="true" title="Italic"
            style={{
              ...(!this.state.italic ? styles.textAttributeIcon : styles.textAttributeIconActive) }}
            onClick={ this.toggleTextItalic }
          />
          <i
            className="fa fa-underline center top" aria-hidden="true" title="Underline"
            style={{ ...(!this.state.underline ? styles.textAttributeIcon : styles.textAttributeIconActive) }}
            onClick={ this.toggleTextUnderline }
          />
        </div>
        <div className="VerticalSep"/>
        <div className="FontSizeBlock">
          <span style={ styles.title }>{t('SIZE_CAPS')}</span>
          <input ref="inputSize"
            style={ styles.inputNumber }
            type="number"
            min="1"
            value={ this.state.fontSize }
            onChange={ this.fontSizeChanged }
          />
        </div>
        {this.state.displayColorPicker &&
        <div style={{
          ...styles.colorPickerContainer,
          top: fontPickerPos === 'bottom' ? '40px' : undefined,
          bottom: fontPickerPos === 'top' ? '40px' : undefined
        }}>
          <SketchPicker
            disableAlpha={true}
            color={ this.props.color }
            onChangeComplete={ this.handleColorChangeComplete }
          />
        </div>
        }
      </div>
    );
  }

}

const styles = {
  textAttributeIcon: {
    width: '30px',
    height: '30px',
    display: 'inline-block',
    marginRight: '10px',
    cursor: 'pointer'
  },
  textAttributeIconActive: {
    width: '30px',
    height: '30px',
    display: 'inline-block',
    marginRight: '10px',
    backgroundColor: 'rgba(235, 106, 92, 0.56)',
    borderRadius: '50%',
    cursor: 'pointer'
  },
  title: {
    height: '13px',
    textTransform: 'uppercase',
    color: '#B5B5B5',
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '1px',
    lineHeight: '15px',
    verticalAlign: 'top',
  },
  inputNumber: {
    margin: '-5px 0 0 0px',
    display: 'inline-block',
    width: '100%',
    height: '19px',
    borderRadius: '2px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 4px 1px rgba(0,0,0,0.04)',
    border: '0',
    verticalAlign: 'top',
  },
  fontColorBtn: {
    display: 'inline-block',
    cursor: 'pointer',
    height: '30px',
    width: '30px',
    marginRight: '10px',
    border: '2px solid #7C7C7C',
    borderRadius: '1px',
    boxShadow: 'inset 0px 0px 0px 2px #FFFFFF',
  },
  colorPickerContainer: {
    position: 'absolute',
    left: '193px',
    top: '40px',
  },
};